import { render, staticRenderFns } from "./RegistrationAndLoginError.vue?vue&type=template&id=2fb4c9f5&scoped=true&"
var script = {}
import style0 from "./RegistrationAndLoginError.vue?vue&type=style&index=0&id=2fb4c9f5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fb4c9f5",
  null
  
)

export default component.exports